"use client";
import React from "react";
import {
    Box,
    Grid,
    Typography,
    Link,
    Stack,
    Divider,
} from "@mui/material";
import Image from "next/image";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DividerComponent } from "@/components";
import { IMAGES } from "@/lib/constants";



const loanTypes = [
    "Personal Loan",
    "Business Loan",
    "Two Wheeler Loan",
    "Used Car Loan",
    "Loan Against Property",
    "Loyalty Loan",
    "Personal Loan by Location",
    "Business Loan by Location",
    "Two Wheeler Loan by Location",
    "Used Car Loan by Location",
    "Loan Against Property by Location", "",
    "Loan By Amount",
    "Calculators",
    "Application Form",
    "Credit/Cibil Score",
    "Quick Pay"
];

let aboutUs = [
    "Hero FinCorp Journey",
    "Certifications & Membership",
    "CEO’s Message",
    "Board of Directors",
    "Leadership Team",
    "Company Policies",
    "CSR Report",
    "DLG HIPL",
]

let investors = [
    "Financial Performance",
    "Notices & Intimations",
    "Unclaimed & Unpaid Dividend",
    "Shareholder Information",
    "Statutory Disclosures",
    "Investor Contact",
    "Press Release",
    "Link to SMART ODR",
    "SEBI Circular on Online Dispute Resolution",
]

let payments = [IMAGES.paytm, IMAGES.zestPayment, IMAGES.prefrPayment, IMAGES.mobiQuick, IMAGES.paisaBazar]

const Footer = () => {
    return (
        <Box sx={{ backgroundColor: "#03211B", color: "#fff", p: 2 }}>

            <Box sx={{ p: 2 }}>
                <Grid container spacing={2}>
                    {loanTypes?.map((type, index) => (
                        <Grid container
                            display={'flex'}
                            alignItems={'center'}
                            gap={1}
                            xs={12}
                            sm={6}
                            md={2}
                            key={index}
                        >
                            {type !== '' && (
                                <Grid item>
                                    <ExpandMoreIcon />
                                </Grid>
                            )}
                            <Grid item >
                                <Typography variant="body2" color="#fff" fontSize={'8.97px'} >
                                    {type}
                                </Typography>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </Box>


            <DividerComponent sx={{ my: 2, backgroundColor: "#878787" }} />

            {/* Row 2: Logo, Social, Info Sections, Partners, App */}
            <Grid container spacing={4}>
                {/* Logo and Social */}
                <Grid item xs={12} md={2} display={'flex'} direction={'column'} alignItems={'center'}>
                    <Image src={IMAGES.logoFooter} alt="Hero FinCorp Logo" width={100} />

                    <Typography textAlign={'center'} color={'#999999'} fontWeight={400} fontSize={"9.72px"} lineHeight={"17.95px"}>
                        We are one of India{`'`}s fastest growing NBFCs,
                        disbursing a loan every 30 seconds.
                    </Typography>
                    <Typography variant="h6" mt={2}>Follow Us</Typography>
                    <Stack direction="row" spacing={1} mt={1}>

                        <Image src={IMAGES.facebook} alt="Facebook" width={'100%'} />

                        <Image src={IMAGES.twitter} alt="Twitter" width={'100%'} />

                        <Image src={IMAGES.youTube} alt="you Tube" width={'100%'} />

                        <Image src={IMAGES.linkedIn} alt="linkedIn" width={'100%'} />
                        <Image src={IMAGES.instagram} alt="Instagram" width={'100%'} />


                    </Stack>
                </Grid>

                {/* About Us */}
                <Grid item xs={12} sm={6} md={2} color={'#fff'}>
                    <Typography variant="h6" gutterBottom fontWeight={700} fontSize={'10.67px'} textTransform={"uppercase"}>ABOUT US</Typography>
                    <Stack spacing={1}>
                        {aboutUs?.map((item, i) => (
                            <Typography key={`${item}-${i}`} variant="body2" color="#fff" fontSize={'9.72px'} >
                                {item}
                            </Typography>
                        ))}
                    </Stack>
                </Grid>

                {/* Investors */}
                <Grid item xs={12} sm={6} md={2}>
                    <Typography variant="h6" gutterBottom fontWeight={700} fontSize={'10.67px'} textTransform={"uppercase"}>INVESTORS</Typography>
                    <Stack spacing={1}>
                        {investors.map((item, i) => (
                            <Typography key={`${item}-${i}`} variant="body2" color="#fff" fontSize={'9.72px'} >
                                {item}
                            </Typography>
                        ))}
                    </Stack>
                </Grid>

                {/* Reach Us */}
                <Grid item xs={12} sm={6} md={2}>
                    <Typography variant="h6" gutterBottom fontWeight={700} fontSize={'10.67px'} textTransform={"uppercase"}>Reach Us</Typography>
                    <Stack spacing={1}>
                        {[
                            "Customer Care",
                            "Offices",
                            "Dealers",
                            "Dealer Login",
                            "Sitemap",
                            "Disclaimer",
                            "careers",
                            "Online EMI Payment T&Cs",
                        ].map((item, i) => {
                            return (
                                <Typography key={`${item}-${i}`} variant="body2" color="#fff" fontSize={'9.72px'} >
                                    {item}
                                </Typography>
                            )
                        })}
                    </Stack>
                </Grid>

                {/* Partners */}
                <Grid item xs={12} sm={6} md={2}>
                    <Typography variant="h6" gutterBottom fontWeight={700} fontSize={'10.67px'} textTransform={"uppercase"}>Our Partners</Typography>
                    <Stack spacing={1} xs={6}>
                        {payments.map((src, i) => (
                            <Image key={`${i}_payments`} src={src} alt={'payments'} width={80} />

                        ))}
                    </Stack>
                </Grid>

                {/* App Download */}
                <Grid item xs={12} md={2}>
                    <Typography variant="h6" gutterBottom fontWeight={700} fontSize={'10.67px'} textTransform={"uppercase"}>Download the App</Typography>
                    <Stack direction="row" spacing={2} alignItems="center" xs={12}>
                        <Image src={IMAGES.loanAppQR} alt="QR Code" width={80} height={80} />
                        <Image src={IMAGES.googlePlayIcon} alt="Google Play" width={100} height={40} />
                    </Stack>
                </Grid>
            </Grid>

            <DividerComponent sx={{ my: 2, backgroundColor: "#878787" }} />

            {/* Row 3: Address and Contact */}
            <Grid container gap={3}>

                <Grid item xs={12} md={4}>
                    <Stack>

                        <Typography variant="h6" gutterBottom fontWeight={700} fontSize={'10.67px'} textTransform={"uppercase"} color={'#FFFFFFD1'}>Our Address</Typography>
                    </Stack>

                    <Stack display={'flex'} direction={'row'} justifyContent={'space-between'}>
                        <Stack>
                            <Typography variant="subtitle2" fontWeight={700} fontSize={'10.67px'} textTransform={"uppercase"} color={'#999999'}>Corporate office:</Typography>
                            <Typography variant="body2" fontSize={'9.72px'} color="#999999">
                                09, Basant Lok Vasant Vihar,<br />
                                New Delhi - 110057<br />
                                Tel. - +91-11-49487150<br />
                                Fax. +91-11-49487197, +91-11-49487198

                            </Typography>

                        </Stack>
                        <Stack>

                            <Typography variant="subtitle2" fontWeight={700} fontSize={'10.67px'} textTransform={"uppercase"} color={'#999999'}>Operation Center:</Typography>
                            <Typography variant="body2" fontSize={'9.72px'} color="#999999">
                                A44 Mohan Co-operative Industrial Estate, <br />
                                Near Mohan Estate Metro Station,<br />

                                Mathura Road New Delhi - 110044 India
                            </Typography>
                        </Stack>
                    </Stack>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Stack>

                        <Typography variant="h6" gutterBottom fontWeight={700} fontSize={'10.67px'} textTransform={"uppercase"} color={'#FFFFFFD1'}>Connect with us</Typography>
                    </Stack>
                    <Stack display={'flex'} direction={'row'} justifyContent={'space-between'}>
                        <Stack>
                            <Typography variant="subtitle2" fontWeight={700} fontSize={'10.67px'} textTransform={"uppercase"} color={'#999999'}>Retail Customer Care Help:</Typography>
                            <Typography variant="body2" fontSize={'9.72px'} color="#999999">

                                Tel: 1800 102 4145<br />
                                Email: CustomerCare@HeroFinCorp.com<br />
                                9:30 AM - 6:30 PM Monday to Saturday

                            </Typography>


                        </Stack>
                        <Stack>

                            <Typography variant="subtitle2" fontWeight={700} fontSize={'10.67px'} textTransform={"uppercase"} color={'#999999'}>Corporate Customer Care Help:</Typography>
                            <Typography variant="body2" fontSize={'9.72px'} color="#999999">

                                Tel: 1800-103-5271<br />
                                Email:  Corporate.Care@HeroFinCorp.com<br />
                                10:00 AM - 6:00 PM, Monday to Friday
                            </Typography>
                        </Stack>
                    </Stack>
                </Grid>

                <Grid item>
                    <Typography variant="body2" fontSize={'9.72px'} color="#999999">
                        IRDAI License No.: CA0074<br />
                        Validity of Current License: <br />22-03-2023 to 21-03-2026<br />
                        Category of Licensee: Corporate Agent (Composite)
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Footer;
